import { useEffect, useState } from "react";
import { Modal, SelectPicker } from "rsuite";
import { Button } from "../../../components";
import api from "../../../services/api";
import logger from "../../../utils/logger";
import { useAuthenticationService } from "../../../services/authentication.service";
import { roles } from "../../../utils/constants";
export default function ChildLinkModal({ open, onClose, emailData, entryData }) {
  const AuthenticationService = useAuthenticationService();
  const [data, setData] = useState([]);
  const [selectedChildId, setSelectedChildId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(AuthenticationService.isInAnyRole(roles.ADMINS));
  function handleChildSelect(value) {
    logger.debug("Selected child ID:", value);
    setSelectedChildId(value);
  }

  function handleSave() {
    const child = data.find((child) => child.childId === selectedChildId);
    if (!child) {
      logger.error("No child selected or found in data");
      return;
    }

    const linkData = {
      winzEntryId: entryData?.id,
      centreId: emailData?.centreId,
      childId: selectedChildId,
      firstname: child.firstName,
      surname: child.surname,
      winzChildName: entryData?.childName,
      winzSwnNumber: entryData?.swn,
    };

    api
      .updateChildLink(entryData?.id, linkData)
      .then((response) => {
        if (response && response.code === "ERR_CANCELED") {
          return;
        }
        onClose();
        logger.debug("Transaction and child lookup created successfully:", response);
      })
      .catch((error) => {
        // swallow error as child likely already exists
      });
  }

  useEffect(() => {
    setLoading(true);
    setSelectedChildId(null);
    api
      .getChildrenByCentre(emailData?.centreId)
      .then((response) => {
        if (response && response.code === "ERR_CANCELED") {
          return;
        }
        setData(response);
      })
      .catch((error) => {
        logger.error("Error fetching children data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [emailData?.centreId]);

  useEffect(() => {
    if (open && data.length > 0) {
      const selectedChild = data.find((child) => child.childId === entryData?.childId);
      if (selectedChild) {
        logger.debug("Setting selected child ID from entryData:", selectedChild.childId);
        setSelectedChildId(selectedChild.childId);
      } else {
        setSelectedChildId(null);
      }
    }
  }, [open, data, entryData?.childId]);

  return (
    <Modal open={open} onClose={onClose} size="md">
      <Modal.Header>
        <Modal.Title data-testid="link-child-modal-title">Link Child - {entryData?.childName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectPicker
          loading={loading}
          title="Select Child"
          data={data}
          value={selectedChildId}
          onChange={handleChildSelect}
          labelKey="childFullName"
          valueKey="childId"
          style={{ width: "100%" }}
          disabled={!isAdmin}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSave}
          appearance="primary"
          text="Link Child"
          color="green"
          disabled={!selectedChildId || !isAdmin}
          data-testid="link-child-button"
        />
        <Button onClick={onClose} appearance="primary" text="Close" color="blue" data-testid="close-child-link-modal" />
      </Modal.Footer>
    </Modal>
  );
}
